import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { bindActionCreators } from 'redux'

import { getAccessToken } from '@driftt/web-auth'

import LoadingPage from 'layouts/LoadingPage'
import * as actions from 'modules/auth/actions'
import { hasSubmittedOnboardingSurvey } from 'utils/extension'
import {
  getVideoSignupReferrer,
  page,
  setVideoSignupReferrer,
} from 'utils/trackingUtils'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      regenerateCode: actions.regenerateCode,
      push,
    },
    dispatch
  ),
})

export default compose(
  connect(null, mapDispatchToProps),
  lifecycle({
    async componentDidMount() {
      // HANDLES REDIRECTING THE USER IMMEDIATELY AFTER THEY INSTALL THE EXTENSION
      const videoReferralSource = getVideoSignupReferrer()
      const cameFromAppSwitcherAndNeedsSurvey =
        videoReferralSource === 'app-switcher' && !hasSubmittedOnboardingSurvey
      let routerCondition = 'webstore-redirect'

      // if you just installed via the app switcher flow, fill out the survey next
      if (cameFromAppSwitcherAndNeedsSurvey) {
        this.props.actions.push('/video/survey')
        routerCondition = 'app-switcher-redirect'

        // if you just installed after creating an account/logging in, we can redirect you to the video app
      } else if (getAccessToken()) {
        this.props.actions.regenerateCode()
        routerCondition = 'regenerate-code'

        // otherwise, you just started the signup flow from the webstore & need to auth
      } else {
        setVideoSignupReferrer({ source: 'webstore', location: 'webstore' })

        // Enforcing manual delay to allow LS value to be set
        setTimeout(() => {
          this.props.actions.push('/video/start')
        }, 250)
      }

      page('Video Landing Page Viewed', {
        source: videoReferralSource,
        context: routerCondition,
      })
    },
  })
)(LoadingPage)
